import "../style/footer.css"

export default function Footer() {
    return (
    <div className="footer">
        <p><span className="copyright">©</span> 2024 - Pierre-Christophe Gam all rights reserved.</p>
    </div>
  )
}
